export default "__VITE_ASSET__d27867b6__"